import { Crown, Check, Loader2 } from "lucide-react";
import { Button } from "./ui/button";

function winners(share) {
  if (!share) return [];
  return Object.entries(share.tallies || {})
    .map(([type, counts]) => {
      const total = counts.reduce((a, b) => a + b, 0);
      if (!total) return null;
      const max = Math.max(...counts);
      const idx = counts.indexOf(max);
      const planned = share.planned?.[type] ?? 0;
      return { type, idx, votes: max, total, option: share.options[type][idx], applied: idx === planned };
    })
    .filter(Boolean);
}

export function CrowdPick({ share, applyingType, onApply, nightIndex }) {
  const picks = winners(share);
  if (!picks.length) return null;
  return (
    <div data-testid={`crowd-pick-${nightIndex}`} className="mt-4 rounded-xl border border-dashed border-border bg-secondary/30 p-3">
      <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
        <Crown size={12} className="text-amber-400" /> Crowd pick
      </span>
      <div className="mt-2 space-y-2">
        {picks.map((p) => (
          <div key={p.type} className="flex items-center justify-between gap-2 text-sm">
            <span className="min-w-0">
              <span className="text-muted-foreground capitalize">{p.type}: </span>
              <span className="font-semibold" data-testid={`crowd-pick-${p.type}-name-${nightIndex}`}>{p.option.name}</span>
              <span className="text-muted-foreground"> · {p.votes}/{p.total}</span>
            </span>
            {p.applied ? (
              <span className="inline-flex items-center gap-1 text-xs font-semibold neon-cyan" data-testid={`crowd-pick-${p.type}-applied-${nightIndex}`}>
                <Check size={13} /> Applied
              </span>
            ) : (
              <Button
                data-testid={`apply-crowd-pick-${p.type}-${nightIndex}`}
                size="sm"
                disabled={!!applyingType}
                onClick={() => onApply(p.type)}
                className="h-7 rounded-full cta-gradient px-3 text-xs font-semibold text-white"
              >
                {applyingType === p.type ? <Loader2 size={13} className="animate-spin" /> : "Apply"}
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
